<h1 mat-dialog-title>{{data.name}}</h1>

<div mat-dialog-actions class="center">
    <button color="warn" mat-flat-button (click)="onNoClick()">Fechar</button>
</div>